import { Box, LinearProgress, Stack, Typography } from '@mui/material';
import { isNil } from 'ramda';

export interface ProgressIndicatorProps {
  message?: string;
  progress?: number;
  progressBarWidth?: string | number | undefined;
}

export const ProgressIndicator = ({ message, progress, progressBarWidth }: ProgressIndicatorProps) => {
  const variant = !isNil(progress) ? 'determinate' : undefined;
  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: 'stretch',
        alignItems: 'center',
        flex: 1,
      }}
    >
      <Box
        sx={{
          minWidth: progressBarWidth,
          maxWidth: progressBarWidth,
          flex: 1,
        }}
      >
        <LinearProgress value={progress} color="primary" variant={variant}></LinearProgress>
      </Box>
      <Typography
        variant="caption"
        noWrap
        sx={{
          paddingLeft: 2,
          minWidth: 0,
          textOverflow: 'ellipsis',
        }}
      >
        {message}
      </Typography>
    </Stack>
  );
};
